import { tenths, toTenths } from '../format';

/** Plan 046: the price range buys must pay, from your risk policy, in tenths of a cent. The order service enforces it;
 *  the screens only disable what it would refuse. */
export type BuyBand = { low: number | null; high: number | null };

export const buyBand = (limits?: { min_buy_price?: string | null; max_buy_price?: string | null } | null): BuyBand | null => {
  const low = toTenths(limits?.min_buy_price), high = toTenths(limits?.max_buy_price);
  return low == null && high == null ? null : { low, high };
};

export const bandText = (band: BuyBand) => `${tenths(band.low ?? 10)}–${tenths(band.high ?? 990)}`;

/** Why a buy at this limit, against this ask, is outside the range; null when it may go. A limit at or above the ask
 *  takes it now, so an ask under the minimum fills under the range. Mirrors the service's `price_band` check. */
export const bandIssue = (band: BuyBand | null, limit: number | null, ask: number | null): string | null => {
  if (!band || limit == null) return null;
  if ((band.low != null && limit < band.low) || (band.high != null && limit > band.high))
    return `Buys are limited to ${bandText(band)}; this limit is ${tenths(limit)}`;
  if (band.low != null && ask != null && ask <= limit && ask < band.low)
    return `The ask is ${tenths(ask)}, under your ${bandText(band)} buy range`;
  return null;
};
